import { CountryCodeValue } from '@/constants/country-codes';

type InputMaskFields = 'bankAccountNumber' | 'taxNumber' | 'zipCode';

const inputMasks: Record<CountryCodeValue, Record<InputMaskFields, string | string[] | null>> = {
    PL: {
        bankAccountNumber: '99 9999 9999 9999 9999 9999 9999',
        taxNumber: '999-999-99-99',
        zipCode: '99-999'
    },
    DE: {
        bankAccountNumber: '99 9999 9999 9999 9999 99',
        taxNumber: null,
        zipCode: '99999'
    },
    HU: {
        bankAccountNumber: '99999999 99999999 99999999',
        taxNumber: '99999999-9-99',
        zipCode: '9999'
    },
    RO: {
        bankAccountNumber: '99 aaaa **** **** **** ****',
        taxNumber: null,
        zipCode: '999999'
    }
};

export default inputMasks;
